<loading [visible]="loading()"></loading>

<section class="flex flex-wrap justify-between items-center gap-3 mb-3">
    <h1 class="text-2xl font-bold text-gray-800">Productos - Vista restaurante</h1>
    <div class="flex items-center gap-2">
        <a routerLink="/products"
            class="px-3 py-2 text-sm font-bold text-gray-600 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors">
            Vista tabla
        </a>
        <add-button label="Nuevo Producto" (onClick)="openEditForm()"></add-button>
    </div>
</section>

<div class="flex flex-col gap-3 mb-4">
    <input type="text" [(ngModel)]="search" placeholder="Buscar por nombre o referencia..."
        class="w-full md:w-96 px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-200">

    <div class="flex flex-wrap gap-2">
        <button (click)="selectCategory('all')"
            class="px-3 py-1.5 text-xs font-bold uppercase tracking-wide rounded-full border transition-colors"
            [class.bg-gray-800]="selectedCategoryId === 'all'" [class.text-white]="selectedCategoryId === 'all'"
            [class.border-gray-800]="selectedCategoryId === 'all'"
            [class.bg-white]="selectedCategoryId !== 'all'" [class.text-gray-500]="selectedCategoryId !== 'all'"
            [class.border-gray-300]="selectedCategoryId !== 'all'">
            Todas
        </button>
        @for(cat of categories; track cat.id){
        <button (click)="selectCategory(cat.id)"
            class="px-3 py-1.5 text-xs font-bold uppercase tracking-wide rounded-full border transition-colors"
            [class]="selectedCategoryId === cat.id ? cat.classes + ' ring-2 ring-offset-1 ring-gray-400' : cat.classes">
            {{ cat.name }}
        </button>
        }
    </div>
</div>

@if(!loading() && groups.length === 0){
<p class="text-gray-500 text-sm">No se han encontrado productos.</p>
}

@for(group of groups; track group.id){
<section class="mb-6">
    <h2 class="inline-block px-2.5 py-1 mb-3 text-xs font-black uppercase tracking-widest rounded-lg border"
        [class]="group.classes">
        {{ group.name }}
    </h2>

    <div class="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3">
        @for(product of group.products; track product.id){
        <button (click)="openEditForm(product)"
            class="relative flex flex-col items-start gap-2 rounded-2xl border-2 p-4 text-left transition-all shadow-sm hover:shadow-md"
            [class]="group.classes">
            <button (click)="openDeleteForm(product, $event)"
                class="absolute top-2 right-2 p-1 rounded-full text-current opacity-50 hover:opacity-100 hover:bg-white/60 transition-opacity"
                title="Eliminar producto">
                <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4" fill="none" viewBox="0 0 24 24"
                    stroke="currentColor" stroke-width="2">
                    <path stroke-linecap="round" stroke-linejoin="round"
                        d="M6 18L18 6M6 6l12 12" />
                </svg>
            </button>

            <span class="text-sm font-black uppercase tracking-tight pr-5">{{ product.name }}</span>
            <span class="text-lg font-black" [centToEurDisplay]="product.price_ticket"></span>
        </button>
        }
    </div>
</section>
}
